import { useEffect, useState } from 'react';
import { useConnectionStore } from '../stores/connectionStore';
import { Icon } from './Icon';

export function ConnectionIndicator() {
  const status = useConnectionStore((s) => s.status);
  const reconnectAttempts = useConnectionStore((s) => s.reconnectAttempts);
  const initOnlineListener = useConnectionStore((s) => s.initOnlineListener);
  const [visible, setVisible] = useState(true);

  // Set up online/offline listeners
  useEffect(() => {
    return initOnlineListener();
  }, [initOnlineListener]);

  // Auto-hide after 2 seconds when connected
  useEffect(() => {
    setVisible(true);
    if (status !== 'connected') return undefined;
    const timer = setTimeout(() => setVisible(false), 2000);
    return () => clearTimeout(timer);
  }, [status]);

  const color =
    status === 'connected' ? '#4caf50' :
    status === 'reconnecting' ? '#ffc107' :
    '#f44336';

  const iconName = status === 'disconnected' ? 'wifi-off' : 'wifi';
  const showLabel = status !== 'connected';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.5s ease',
        pointerEvents: 'none',
      }}
    >
      <Icon
        name={iconName}
        size={14}
        color={color}
        style={{
          filter: `drop-shadow(0 0 4px ${color})`,
          animation: status === 'reconnecting' ? 'pulse 1.5s infinite' : undefined,
        }}
      />
      {showLabel && (
        <span
          style={{
            fontSize: '11px',
            color,
            fontFamily: 'var(--font-display)',
            letterSpacing: '0.05em',
          }}
        >
          {status === 'reconnecting'
            ? `Reconnecting${reconnectAttempts > 1 ? ` (${reconnectAttempts})` : ''}...`
            : 'Disconnected'}
        </span>
      )}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}
